
import React from 'react';
import AdminDocumentManagement from '@/components/admin/AdminDocumentManagement';

const AdminDocumentsPage = () => {
  
  return <AdminDocumentManagement />;
};

export default AdminDocumentsPage;
